<template>
<div class="ViewNoteElementOverlay">
  <div class="container-fluid">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer">
              <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-Top-3Perc float-right" alt="close-icon" @click="closeOverlay">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold lesson-font-styles">
          {{getLessonObj.Title}}
          </div>    
        </div>
        <div class="row margin-bottom-2Perc margin-left-15px bottom-border">
          <div class="col-md-6 col-lg-6 text-align-left font-styles  orange-text-color">
            {{getDescTypeTextValue}}
          </div>
          <div class="col-md-6 col-lg-6 text-align-right padding-right-0px" v-if="this.elementObj.RDType === 1">Allowed Response Type(s): {{feedbackStr}}</div>
          <div class="col-md-6 col-lg-6 text-align-right padding-right-0px" v-else></div>
        </div>
        <div class="row margin-bottom-2Perc padding-left-4Point4">
          <div class="row" v-if="AudioUrlValue !== undefined && AudioUrlValue !== 'null' && AudioUrlValue !== null && AudioUrlValue !== ''">
            <div class="col-md-4 col-md-offset-4 col-lg-4 col-lg-offset-4">
              <audio class="audio-width" controls controlsList="nodownload">
                <source :src="AudioUrlValue" type="audio/mp3">
              </audio>
            </div>
            <div class="col-md-4 col-lg-4"></div>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12 text-align-left" v-html="contentValue"></div>
          </div>
        </div>
        <div class="row">
        </div>         
      </div>
    </div> 
  </div>
</div>
</template>

<script>
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['elementObj', 'lessonObj'],
  created: function () {
    this.setDefaultsValues()
    this.getAllowedFeebackTypeString()
  },
  data: function () {
    return {
      feedbackStr: '',
      allowedResponseTypeArr: [],
      descVideoTypeText: ''
    }
  },
  name: 'ViewNoteElementOverlay',
  methods: {
    setDefaultsValues: function () {
      if (parseInt(this.getElementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
        this.descVideoTypeText = this.getElementObj.Title + ' [Teachback]'
      } else {
        this.descVideoTypeText = this.getElementObj.Title
      }
    },
    closeOverlay: function () {
      var obj = {
        closeOverlay: false,
        isUpdated: false
      }
      this.$emit('closeOverlay', obj)
    },
    getAllowedFeebackTypeString: function () {
      if (this.elementObj.RDType === constants.DescVideoType.Teachback) {
        if (this.elementObj.AllowedResponseTypes !== null && this.elementObj.AllowedResponseTypes !== 'null' && this.elementObj.AllowedResponseTypes !== '' && this.elementObj.AllowedResponseTypes !== undefined) {
          if (this.checkResponseTypeOccurance('0', this.elementObj.AllowedResponseTypes)) {
            this.allowedResponseTypeArr.push(0)
          }
          if (this.checkResponseTypeOccurance('1', this.elementObj.AllowedResponseTypes)) {
            this.allowedResponseTypeArr.push(1)
          }
          if (this.checkResponseTypeOccurance('2', this.elementObj.AllowedResponseTypes)) {
            this.allowedResponseTypeArr.push(2)
          }
        } else {
          this.allowedResponseTypeArr = [0]
        }
      } else {
        this.allowedResponseTypeArr = []
      }

      for (var i = 0; i < this.allowedResponseTypeArr.length; i++) {
        switch (parseInt(this.allowedResponseTypeArr[i])) {
          case 0:
            this.feedbackStr += 'Video'
            break
          case 1:
            this.feedbackStr += 'Audio'
            break
          case 2:
            this.feedbackStr += 'Note'
            break
        }
        if (i < (this.allowedResponseTypeArr.length - 1)) {
          this.feedbackStr += ', '
        }
      }
    },
    checkResponseTypeOccurance: function (stringToCheck, originalString) {
      return originalString.indexOf(stringToCheck) !== -1
    }
  },
  components: {},
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getElementObj: {
      get: function () {
        return this.elementObj
      }
    },
    AudioUrlValue: {
      get: function () {
        return this.getElementObj.AudioUrl
      }
    },
    getDescTypeTextValue: {
      get: function () {
        return this.descVideoTypeText
      }
    },
    contentValue: {
      get: function () {
        var updatedNewValue = dmAdminUtils.updateUrls(this.getElementObj.Content)
        return updatedNewValue
      }
    }
  }
}
</script>

<style scoped>
.ViewNoteElementOverlay {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2% !important;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000 !important;
}
.red-border{
  border:1px solid red;
}
.align-center {
    margin: auto;
    /* width: 50%; */
    /* border: 3px solid green; */
    /* padding: 10px; */
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.font-styles {
  font-size: 14px;
  color: #34495e;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-3Perc {
  margin-right: 3%;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.lesson-font-styles {
  font-size: 20px;
  color: #34495e;
}
.orange-text-color {
 color: #f39c12 !important;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
    margin-left:1.6%;
}
.border-red {
  border: 1px solid red;
}
.padding-right-28px {
  padding-right: 28px;
}
.padding-right-0px {
  padding-right: 0px;
}
.margin-left-15px {
  margin-left:15px;
}
</style>





// WEBPACK FOOTER //
// src/components/view_element/ViewNoteElementOverlay.vue